import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { Menu, X } from 'lucide-react';
import { Logo } from './Logo';
import { Button } from './Button';

interface LayoutProps {
  children: React.ReactNode;
}

export const Layout: React.FC<LayoutProps> = ({ children }) => {
  const navigate = useNavigate();
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  const toggleMobileMenu = () => {
    setMobileMenuOpen(!mobileMenuOpen);
  };

  const closeMobileMenu = () => {
    setMobileMenuOpen(false);
  };

  return (
    <div className="layout">
      <header className="header">
        <div className="header-container">
          {/* Logo */}
          <Link to="/" className="logo-link" onClick={closeMobileMenu}>
            <Logo size="md" variant="full" />
          </Link>

          {/* Desktop Navigation */}
          <nav className="nav desktop-nav">
            <Link to="/" className="nav-link">Home</Link>
            <Link to="/loan-products" className="nav-link">Loan Products</Link>
          </nav>

          {/* Desktop Actions */}
          <div className="header-actions desktop-actions">
            <Button variant="secondary" size="md" onClick={() => navigate('/login')}>
              Sign In
            </Button>
            <Button variant="primary" size="md" onClick={() => navigate('/register')}>
              Get Started
            </Button>
          </div>

          {/* Mobile Hamburger Menu Button */}
          <button
            className="mobile-menu-button"
            onClick={toggleMobileMenu}
            aria-label="Toggle menu"
            aria-expanded={mobileMenuOpen}
          >
            {mobileMenuOpen ? <X size={24} /> : <Menu size={24} />}
          </button>
        </div>

        {/* Mobile Menu Overlay */}
        {mobileMenuOpen && (
          <div className="mobile-menu-overlay" onClick={closeMobileMenu}>
            <nav className="mobile-nav" onClick={(e) => e.stopPropagation()}>
              <Link to="/" className="mobile-nav-link" onClick={closeMobileMenu}>
                Home
              </Link>
              <Link to="/loan-products" className="mobile-nav-link" onClick={closeMobileMenu}>
                Loan Products
              </Link>
              <div className="mobile-nav-divider"></div>
              <Button
                variant="secondary"
                size="lg"
                fullWidth
                onClick={() => { navigate('/login'); closeMobileMenu(); }}
              >
                Sign In
              </Button>
              <Button
                variant="primary"
                size="lg"
                fullWidth
                onClick={() => { navigate('/register'); closeMobileMenu(); }}
              >
                Get Started
              </Button>
            </nav>
          </div>
        )}
      </header>

      <main className="main-content">
        {children}
      </main>

      <footer className="footer">
        <div className="footer-container">
          <p>&copy; 2025 Coin MFI. Fast, secure microfinance loans. All rights reserved.</p>
          <p className="footer-powered-by">
            Powered by <a href="https://www.aionloop.ca" target="_blank" rel="noopener noreferrer">www.aionloop.ca</a>
          </p>
        </div>
      </footer>
    </div>
  );
};
